/**
 * Initializes Swiper instances for product visuals and thumbnails.
 * Sets up a vertical thumbnail slider and links it to the main product visual slider.
 * Enables lazy loading for both sliders.
 */
function initFpVisuals() {
    let thumbs = new Swiper(".product-thumbs", {
        direction: "vertical",
        slidesPerView: 3,
        roundLengths: true,
        mousewheel: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        centeredSlides: false,
        slideToClickedSlide: true,
        releaseOnEdges: true,
    });

    let visual = new Swiper(".product-visual", {
        lazy: true,
        roundLengths: true,
        thumbs: {
            swiper: thumbs,
        },
        pagination: {
            el: '.product-visual-pagination',
            clickable: true,
        },
    });

    visual.on('slideChange', () => {
        const i = visual.realIndex;
        thumbs.slideTo(i);
    });
}


/** Syncs the height of the thumbnail container with the main product visual container.
 * Ensures consistent layout and alignment between the two sections.
 */
function syncThumbsHeight() {
    var visual = document.querySelector('.product-visual');
    var thumbs = document.querySelector('.product-thumbs');
    if (visual && thumbs) {
        thumbs.style.height = visual.offsetHeight + 'px';
    }
}

document.addEventListener('DOMContentLoaded', syncThumbsHeight);
document.addEventListener('DOMContentLoaded', displaySelectedColor);
document.addEventListener('DOMContentLoaded', initFpVisuals);
window.addEventListener('resize', syncThumbsHeight);
window.addEventListener("orientationChange", syncThumbsHeight);

function displaySelectedColor() {
    if (!document.querySelector("#product-selected-color")) return;

    document.querySelector("#product-selected-color").innerHTML = document.querySelector('input[name="prod_color"]:checked').getAttribute("data-nom").toLowerCase();
}

document.addEventListener('click', function (event) {
    if (event.target.matches('.modal-size-label, .modal-size-label > span')) {
        document.querySelector('#prod_size_' + event.target.getAttribute('data-product-id') + '_' + event.target.getAttribute('data-size-id')).click();

        // Fire a custom event to notify that a size has been selected from the modal
        const sizeSelectedEvent = new CustomEvent('sizeSelectedFromModal');
        document.dispatchEvent(sizeSelectedEvent);

        setTimeout(function () {
            closeModal('size-selector');
        }, 0);
    }
});

document.addEventListener('click', function (event) {
    if (event.target.matches('.product-add-alert-button')) {
        document.querySelector('.product-add-alert-button').setAttribute('is-hidden', '');
        document.querySelector('.alert-stock-wrapper').removeAttribute('is-hidden');
    }
});

document.addEventListener('click', function (event) {
    if (event.target.matches('.product-feature h2')) {
        const content = event.target.nextElementSibling;

        if (content.hasAttribute('is-collapsed')) {
            document.querySelectorAll('.product-feature-content[is-displayed]').forEach((el) => {
                slideUp(el);
            });
            slideDown(content);
        } else {
            slideUp(content);
        }
    }
});

function setAddFormProductAttribute() {
    const formWrapper = document.querySelector('.product-form');
    const form = document.querySelector('.productsheet-form');

    if (!formWrapper || !form) return;

    if (!isInViewport(formWrapper)) {
        setAttributes(form, {'is-fixed': '', 'is-visible': ''});
    } else {
        removeAttributes(form, ['is-visible', 'is-fixed']);
    }
}

window.addEventListener('DOMContentLoaded', setAddFormProductAttribute);
window.addEventListener('scroll', setAddFormProductAttribute);

function initRecentlyBrowsed() {
    const recentlyBrowsed = document.querySelector('.recently-browsed-slider');

    new Swiper(recentlyBrowsed, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
            nextEl: '.recentlyBrowsedNext',
            prevEl: '.recentlyBrowsedPrev',
        }
    });
}

if (document.querySelector('.recently-browsed-slider')) {
    initRecentlyBrowsed();
}

(function () {
    if (document.querySelector('.productsheet-form') && document.querySelector('.productsheet-form').hasAttribute('is-unique-size')) {
        checkProductInWishlist(document.querySelector('.productsheet-form').getAttribute('data-product-id'));
    }
})();
